import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
// import { fetchDeviceTree } from '@blade-sxp/monitor/api/device-management/control';
import { isEmpty, isArray, cloneDeep, isNil } from 'lodash';
import { HandleDeviceIdTree } from '@blade/common/store/deviceTree';
import { getDeviceRegion } from '@blade-sxp/task-management/api/creat-task/index';
import { getDevicesGroupTree } from '@blade-sxp/device-management/api/device-group-management/index';
import { AppModule } from '@blade/common/store/app';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
const Service = { getDeviceRegion };
let DeviceCascader = class DeviceCascader extends Vue {
    multiple;
    clearable;
    disabled;
    collapseTags;
    customedDisabledFunc;
    value;
    searchCondition;
    options = [];
    taskType = '';
    get deviceIdList() {
        let data = [];
        if (this.multiple) {
            data = this.value;
        }
        else {
            if (!isEmpty(this.value) && isArray(this.value)) {
                data = this.value?.[0];
            }
            else {
                data = '';
            }
        }
        return data;
    }
    set deviceIdList(val) {
        if (this.multiple) {
            this.$emit('input', val);
        }
        else {
            if (!isEmpty(val)) {
                this.$emit('input', [val]);
            }
            else {
                this.$emit('input', []);
            }
        }
    }
    get language() {
        return AppModule.language;
    }
    onChangeDeviceId(val, oldVal) {
        if (this.multiple) {
            if (!isEmpty(val) && val.length > 100) {
                this.$nextTick(() => {
                    this.deviceIdList = oldVal;
                    this.$message({
                        customClass: 'more-message',
                        showClose: true,
                        message: `${this.$t('moreTip')}`,
                        iconClass: 'war-icon',
                    });
                });
            }
            if (!isEmpty(val) && val.length === 100) {
                this.disabledTree();
            }
            if (val.length < 100) {
                this.allTree();
            }
        }
    }
    created() {
        this.taskType = this.$route.query.taskType;
        this.getTree();
    }
    beforeDestroy() {
        HandleDeviceIdTree.updataTreeIsDdata(false);
        DeviceIdDataModule.updateCurrentDeviceDetails({});
    }
    allTree() {
        const deep = (treeData) => {
            return treeData.map((item) => {
                if (!isEmpty(item.children)) {
                    deep(item.children);
                }
                item.disabled = false;
                return {
                    ...item,
                };
            });
        };
        return deep(this.options);
    }
    disabledTree() {
        const deep = (treeData) => {
            return treeData.map((item) => {
                if (this.deviceIdList.includes(item.id) && item.nodeType !== 'DEVICE_GROUP') {
                    item.disabled = false;
                    return {
                        ...item,
                    };
                }
                else if (!this.deviceIdList.includes(item.id) && item.nodeType !== 'DEVICE_GROUP') {
                    item.disabled = true;
                    return {
                        ...item,
                    };
                }
                if (!isEmpty(item.children)) {
                    deep(item.children);
                }
            });
        };
        return deep(this.options);
    }
    async getTree() {
        try {
            let data = [];
            // const { trees } = (await fetchDeviceTree()) as any;
            const params = { lang: this.language, ...this.searchCondition };
            const treeGroupList = (await getDevicesGroupTree(params));
            let deviceTypeList = Object.keys(treeGroupList);
            deviceTypeList.forEach((deviceType, i) => {
                let item = {
                    id: deviceType,
                    name: deviceType,
                    nodeType: 'DEVICE_GROUP',
                    children: treeGroupList[deviceType],
                    canPlay: false,
                    parentId: '0',
                    status: 'null',
                };
                data.push(item);
            });
            this.options = this.mapTree(data) || [];
            HandleDeviceIdTree.getDeviceIdList(data);
            HandleDeviceIdTree.setMapValue();
            if (!isEmpty(data)) {
                this.$emit('data-finish', true);
                HandleDeviceIdTree.updataTreeIsDdata(true);
            }
            else {
                this.$emit('data-finish', false);
                HandleDeviceIdTree.updataTreeIsDdata(false);
            }
        }
        catch (error) {
            throw error;
        }
    }
    mapTree(originTree) {
        if (!isEmpty(originTree)) {
            const treeArr = cloneDeep(originTree);
            const deepTree = (treeList) => {
                for (let i = treeList.length - 1; i > -1; i--) {
                    const { children, nodeType, id } = treeList[i];
                    const isGroup = nodeType === 'DEVICE_GROUP';
                    const idDevice = nodeType === 'DEVICE';
                    if (isGroup) {
                        treeList[i].id = id + `DEVICE_GROUP`;
                    }
                    treeList[i].disabled = false;
                    if (isGroup && children && children.length === 0) {
                        treeList.splice(i, 1);
                    }
                    if (idDevice && children && children.length === 0) {
                        treeList[i].children = null;
                    }
                    if (children.length > 0) {
                        deepTree(children);
                    }
                }
            };
            deepTree(treeArr);
            return treeArr;
        }
    }
    remove(val) {
        if (this.multiple) {
            this.$emit('remove-value', val);
        }
    }
    changeValue(val) {
        DeviceIdDataModule.updateCurrentDeviceDetails({});
        const taskTypeSingleChoice = ['CROWD_CROSS_LINE_STATISTIC', 'CROWD_STATISTIC'];
        if (taskTypeSingleChoice.includes(this.taskType) && !isEmpty(val)) {
            Service.getDeviceRegion(val).then((res) => {
                DeviceIdDataModule.updateCurrentDeviceDetails(res);
                if (isNil(res.hasLinkedMap) || !res.hasLinkedMap) {
                    this.$alert(`${this.$t('hasLinkedMap', { camera: res.name })}`, `${this.$t('tip')}`, {
                        confirmButtonText: `${this.$t('know')}`,
                        confirmButtonClass: 'confirm-roi-tip',
                    });
                    this.deviceIdList = '';
                    return;
                }
                if (res.zoneStatus !== 'ENABLE') {
                    this.$alert(`${this.$t('status', { camera: res.name })}`, `${this.$t('tip')}`, {
                        confirmButtonText: `${this.$t('know')}`,
                        confirmButtonClass: 'confirm-roi-tip',
                    });
                    this.deviceIdList = '';
                    return;
                }
                if (!res.hasUploadedMap) {
                    this.$alert(`${this.$t('hasUploadedMap', { camera: res.name })}`, `${this.$t('tip')}`, {
                        confirmButtonText: `${this.$t('know')}`,
                        confirmButtonClass: 'confirm-roi-tip',
                    });
                    this.deviceIdList = '';
                    return;
                }
                if (isEmpty(res.vertices)) {
                    this.$alert(`${res.name} ${this.$t('noVertices')}`, `${this.$t('tip')}`, {
                        confirmButtonText: `${this.$t('know')}`,
                        confirmButtonClass: 'confirm-roi-tip',
                    });
                    this.deviceIdList = '';
                }
            });
        }
        this.$emit('change', val);
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], DeviceCascader.prototype, "multiple", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DeviceCascader.prototype, "clearable", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DeviceCascader.prototype, "disabled", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], DeviceCascader.prototype, "collapseTags", void 0);
__decorate([
    Prop()
], DeviceCascader.prototype, "customedDisabledFunc", void 0);
__decorate([
    Prop()
], DeviceCascader.prototype, "value", void 0);
__decorate([
    Prop()
], DeviceCascader.prototype, "searchCondition", void 0);
__decorate([
    Watch('deviceIdList', { deep: true })
], DeviceCascader.prototype, "onChangeDeviceId", null);
DeviceCascader = __decorate([
    Component({
        name: 'DeviceCascader',
        components: {},
        i18n: {
            messages: {
                en: {
                    placeholderTip: 'all device',
                    moreTip: 'A maximum of 100 devices can be selected simultaneously.',
                    know: 'I got it!',
                    tip: 'Tips',
                    hasUploadedMap: 'A map has not been uploaded to Area where {camera} resides. Therefore, the task cannot run normally. Please upload the map in map management',
                    hasLinkedMap: 'The task cannot run properly because {camera} has not been added to the map. Go to map management to add the device',
                    status: 'Area where {camera} resides is disabled, and the task cannot run normally. Please enable the area in map management',
                    noVertices: 'has not been punctuated in the map, and the task cannot run normally, please go punctuate this device on map in map management',
                },
                zh: {
                    placeholderTip: '设备列表',
                    moreTip: '最多可同时选择100台设备。',
                    know: '我知道了',
                    tip: '提示',
                    hasUploadedMap: '{camera} 所在的区域 Check in Area 还未上传地图，任务无法正常运行，请前往地图管理中上传地图',
                    hasLinkedMap: '{camera} 还未在地图中添加，任务无法正常运行，请前往地图管理中添加设备',
                    status: '{camera} 所在的区域 Check in Area 已停用，任务无法正常运行，请前往地图管理中启用该区域',
                    noVertices: '还未在地图中标点，任务无法正常运行，请前往地图管理中标点此设备',
                },
            },
        },
    })
], DeviceCascader);
export default DeviceCascader;
